import { render } from "./WhatsNew.vue?vue&type=template&id=0089620e&scoped=true"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"

import "./WhatsNew.vue?vue&type=style&index=0&id=0089620e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0089620e"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab,QTabs});
